import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { ArrowLeft } from 'lucide-react';
interface Slide6Props {
  onBack: () => void;
}
export function Slide6({
  onBack
}: Slide6Props) {
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 3,
    total: 3
  }} onBack={onBack} data-id="element-206">
      <div className="w-full max-w-5xl mx-auto space-y-4" data-id="element-207">
        <h1 className="text-2xl font-bold text-primary text-center mb-2" data-id="element-208">
          Safety overview
        </h1>
        <div className="bg-white rounded-2xl shadow-xl p-6 border border-teal-100/50" data-id="element-209">
          <div className="flex items-center justify-center mb-3" data-id="element-210">
            <img src="https://cdn.magicpatterns.com/uploads/a6TaZ8C5KaW5mSvaejmhLU/Screenshot_2026-02-16_at_13.32.32.png" alt="Safety overview - doctor, injection, and eye" className="w-full max-w-lg h-auto rounded-lg" data-id="element-211" />
          </div>
          <p className="text-sm text-gray-700 text-center leading-relaxed" data-id="element-212">
            Vabysmo<sup data-id="element-213">®</sup> is administered as an intravitreal injection
            and should be used in accordance with the Summary of Product
            Characteristics.<sup data-id="element-214">¹</sup>
          </p>
        </div>
        <div className="flex justify-center pt-2" data-id="element-215">
          <Button variant="primary" onClick={onBack} data-id="element-216">
            <ArrowLeft className="w-5 h-5" data-id="element-217" />
            Back to menu
          </Button>
        </div>
      </div>
    </SlideLayout>;
}